<div class="ticket-list-container">
    <div class="ticket-detail-container">
        <div
            id="ticket-detail-panel"
            style="float: left"
            [ngClass]="{
                'ticket-detail-panel-cut':
                    rightPanelService.isRightPanelOpened && !ticketRightPanelService.isRightPanelOpened,
                'ticket-detail-panel-full-cut':
                    rightPanelService.isRightPanelOpened && ticketRightPanelService.isRightPanelOpened,
            }">
            @if (ticketDetailsPanelService.isTicketDetailsOpened) {
                <app-ticket-details></app-ticket-details>
            }
        </div>

        @if (rightPanelService.isRightPanelOpened) {
            <app-right-panel
                style="float: right; height: 100%; display: block; overflow-y: auto"
                class="right-panel"></app-right-panel>
        }
    </div>
</div>
@if (rightPanelService.isRightPanelOpened) {
    <bs-modal-backdrop
        (click)="rightPanelService.close()"
        class="modal-backdrop modal-backdrop-rightPanel fade in show"></bs-modal-backdrop>
}
